<template>

  <div class="animated fadeIn overflow-auto" style="max-height: 400px;min-height: 300px;">
    <b-card>
      <b-row>
        <b-col>
          <b-table id="saleTable"
                   :items="ticketItems"
                   :fields="fields"
                   :small="true"
                   foot-clone
                   responsive
                   caption-top
                   selectable
                   @row-clicked="onRowClicked"
                   @row-selected="onRowSelected"
                   select-mode="single">
            <template v-slot:table-caption>
                <b-row>
                  <b-col cols="12">
                    <scan-barcode-product
                      id="barCodeInput"
                      ref="barCodeInput"
                      name="barCodeInput"
                      @found-product="addProductByBarcode"
                      :systemid="systemid"
                    ></scan-barcode-product>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <h3>Products Selected:</h3>
                  </b-col>
                </b-row>
              </template>

            <template v-slot:cell(total)="data">
                <b>{{ data.value }}</b>
              </template>
            <template v-slot:cell(actualPrice)="data">{{ (data.value ? data.value: 0) }}</template>
            <template v-slot:cell(qty)="data">
                <b-form-spinbutton
                  :value="ticketItems[data.index].qty"
                  @change="qtyIncreasd($event, data)"
                  min="1"
                  max="10000"
                  :ref="`spin-${data.index}`"
                  inline
                ></b-form-spinbutton>
              </template>
            <template v-slot:thead-top="data">
                <b-tr>
                  <b-th colspan="2">
                    <span class="sr-only"></span>
                  </b-th>
                  <b-th colspan="1" variant="danger">Total Units: {{getQtyTotal()}}</b-th>
                  <b-th variant="primary">Total Amount: {{getLinesTotal()}}</b-th>

                </b-tr>
              </template>
            <template v-slot:foot(qty)="data">
                <b variant="primary">Total Units: {{getQtyTotal()}}</b>
              </template>
            <template v-slot:foot(total)="data">
                <b variant="primary">Total Amount: {{getLinesTotal()}}</b>
              </template>
            <template v-slot:foot()="data">
                <span></span>
              </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <b-modal ref="modalParkedSalesTable"
               title="Parked Sales"
               hide-footer
               @hide="hideParkedSalesTable"
               no-enforce-focus>
        <parked-sales-table :parkedSales="parkItems"
                            @success="parkedSalesTableSuccess"
                            @cancel="cancelParkedSalesTable" />
      </b-modal>
      <b-modal ref="modalPayment"
               title="Submit Bhent"
               hide-footer
               @hide="hidePaymentModal"
               no-enforce-focus>
        <payment-form :total="getLinesTotal()"
                      @success="PaymentFormSuccess"
                      @cancel="PaymentFormCancel" />
      </b-modal>
    </div>
  </div>

</template>


<script>
  import VueLodash from 'vue-lodash'
  import moment from 'moment'
  import map from 'lodash/map'
  import Vue from 'vue'
  import ParkedSalesTable from './ParkedSalesTable'
  import PaymentForm from './PaymentForm'
  import ScanBarcodeProduct from './ScanBarcodeProduct'

  export default {
    name: 'SaleTicketItems',
    props: {
      systemid: {
        type: String,
        default: '',
      }

    },
    components: {
      'parked-sales-table': ParkedSalesTable,
      'scan-barcode-product': ScanBarcodeProduct,
      'payment-form': PaymentForm
    },
    compute: {},

    data: function() {
      return {
        ticketItems: [],
        parkItems: [],
        fields: [
          { key: 'name', label: 'Item' },
          { key: 'actualPrice', label: 'Price' },
          { key: 'qty', label: 'Units' },
          { key: 'total', label: 'Total' },

        ],
        selectedIndex: -1,
        barCode: ''
      }
    },
    methods: {
      addProductByBarcode(product){
          this.$emit('product-by-barcode', product)
      },
      submitCash() {
          this.$refs.modalPayment.show();
      },
      hidePaymentModal() {
        this.$refs.modalPayment.hide()
      },
      PaymentFormSuccess(payment) {
        const tempTicketItems = JSON.parse(JSON.stringify(this.ticketItems))
        console.log(tempTicketItems);
        let lines = map(tempTicketItems, function(p){
          if(p.hasOwnProperty('fromdate')){
            return {
              productid: p.id,
              catid: p.categoryId,
              price: p.price,
              qty: p.qty,
              actualPrice: p.actualPrice,
              systemid: p.systemid,
              total: p.total,
              productname: p.name,
              fromdate: new Date(p.fromdate).toLocaleDateString(),
              todate: new Date(p.todate).toLocaleDateString()
            }
          }
          else{
            return {
              productid: p.id,
              catid: p.categoryId,
              price: p.price,
              qty: p.qty,
              actualPrice: p.actualPrice,
              systemid: p.systemid,
              total: p.total,
              productname: p.name
            }
          }

        });
        let params = {
          paymentoptions: payment,
          ticketlines: lines
        }
        this.hidePaymentModal();
        this.$emit('processpayment', params)
      },
      PaymentFormCancel() {
        this.$refs.modalParkedSalesTable.hide()
        this.$emit('paymentCancel')
      },
      hideParkedSalesTable() {
        this.$refs.modalParkedSalesTable.hide()
      },
      parkedSalesTableSuccess(selectedSale) {
        if (selectedSale != null) {
          const index = this.parkItems.findIndex(item => item.saleDateTime == selectedSale.key)
          if (index >= 0) {
            this.ticketItems = []
            this.ticketItems = selectedSale.saleData
            this.parkItems.splice(index, 1)
          }
        }
        this.$refs.modalParkedSalesTable.hide()
      },
      cancelParkedSalesTable() {
        this.$refs.modalParkedSalesTable.hide()
      },
      getLinesTotal() {
        return this.sum('total')
      },
      getQtyTotal() {
        return this.sum('qty')
      },
      sum(prop) {
        return this.ticketItems.reduce(function(a, b) {
          return a + b[prop]
        }, 0)
      },
      addProduct(product) {
        product.qty = product.qty ? product.qty : 1;
        product.price = product.price ? product.price : 0
        if(product.hasOwnProperty('fromdate')){
          var totalDays = this.getNumberOfDays(product.fromdate, product.todate);
          product.total = product.qty * product.price * totalDays;
        }
        else{
          product.total = product.qty * product.price
        }

        this.ticketItems.push(product)
        console.log(this.ticketItems)
      },
      updateSelectedProductDates(product){
        if (product != null && this.selectedIndex != -1 && this.ticketItems[this.selectedIndex] != null) {
          var selectedProduct = this.ticketItems[this.selectedIndex]
          if (selectedProduct.id === product.id) {
            this.ticketItems[this.selectedIndex].fromdate = product.fromdate
            this.ticketItems[this.selectedIndex].todate = product.todate
            var totalDays = this.getNumberOfDays(product.fromdate, product.todate)
            this.ticketItems[this.selectedIndex].total = product.qty * product.price * totalDays;
            delete this.ticketItems[this.selectedIndex]['isEditing']
          }
        } else if (product == null && this.selectedIndex != -1 && this.ticketItems[this.selectedIndex] != null) {
          delete this.ticketItems[this.selectedIndex]['isEditing']
        }
      },
      getNumberOfDays(start, end) {
    /*    const date1 = new Date(start);
        const date2 = new Date(end);

        // One day in milliseconds
        const oneDay = 1000 * 60 * 60 * 24;

        // Calculating the time difference between two dates
        const diffInTime = date2.getTime() - date1.getTime();

        // Calculating the no. of days between two dates
        const diffInDays = Math.round(diffInTime / oneDay);

        return diffInDays;
        */
        const startdate = moment(new Date(start));
        const enddate = moment(new Date(end));
        return enddate.diff(startdate, 'days') + 1;

      },

      priceQtyChanged(product) {
        if (product != null && this.selectedIndex != -1 && this.ticketItems[this.selectedIndex] != null) {
          var selectedProduct = this.ticketItems[this.selectedIndex]
          if (selectedProduct.id === product.id) {
            this.ticketItems[this.selectedIndex].qty = product.qty
            this.ticketItems[this.selectedIndex].price = product.price
            this.ticketItems[this.selectedIndex].actualPrice = product.actualPrice
            if(this.ticketItems[this.selectedIndex].hasOwnProperty('fromdate')){
              var totalDays = this.getNumberOfDays(this.ticketItems[this.selectedIndex].fromdate, this.ticketItems[this.selectedIndex].todate);
              this.ticketItems[this.selectedIndex].total = this.ticketItems[this.selectedIndex].qty * this.ticketItems[this.selectedIndex].price * totalDays;
            }
            else{
              this.ticketItems[this.selectedIndex].total =
                this.ticketItems[this.selectedIndex].qty * this.ticketItems[this.selectedIndex].price
            }


            console.log(this.ticketItems)
            delete this.ticketItems[this.selectedIndex]['isEditing']
            console.log(this.ticketItems)
          }
        } else if (product == null && this.selectedIndex != -1 && this.ticketItems[this.selectedIndex] != null) {
          delete this.ticketItems[this.selectedIndex]['isEditing']
          console.log(this.ticketItems)
        }
      },
      qtyIncreasd(e, data) {
        this.$nextTick(function() {
          var origQty = this.ticketItems[data.index].qty
          this.ticketItems[data.index].qty = e
          const tempTicketItems = JSON.parse(JSON.stringify(this.ticketItems[data.index]))
          let productQtyIncrease = {
            index: data.index,
            product: tempTicketItems,
            origQty: origQty
          }
          this.$emit('qtyChanged', productQtyIncrease)
        })
      },
      changeProductQty(index, isValid, origQty) {
        if (isValid == false) {
          this.ticketItems[index].qty = origQty
          var spingRef = 'spin-' + index
          this.$refs[spingRef].localValue = origQty
        }
        if(this.ticketItems[index].hasOwnProperty('fromdate')){
          var totalDays = this.getNumberOfDays(this.ticketItems[index].fromdate, this.ticketItems[index].todate);
          this.ticketItems[index].total = this.ticketItems[index].qty * this.ticketItems[index].price * totalDays;
        }
        else{
          this.ticketItems[index].total = this.ticketItems[index].qty * this.ticketItems[index].price;
        }
        console.log(this.ticketItems)
      },
      getProductToBeDelete() {
        let returnProduct = null
        if (this.selectedIndex != -1) {
          returnProduct = JSON.parse(JSON.stringify(this.ticketItems[this.selectedIndex]))
        }
        return returnProduct
      },

      getProductToBeEdited() {
        let returnProduct = null
        if (this.selectedIndex != -1) {
          returnProduct = JSON.parse(JSON.stringify(this.ticketItems[this.selectedIndex]))
          this.ticketItems[this.selectedIndex].isEditing = true
        }
        return returnProduct
      },
      deleteProduct() {
        if (this.selectedIndex != -1) {
          this.ticketItems.splice(this.selectedIndex, 1)
          this.showSuccessMsg({
            message: 'Selected Product Line deleted successfully.'
          })
        } else {
          this.showErrorMsg({
            message: 'Please select Product Line before clicking Delete Line.'
          })
        }
      },
      onRowSelected(items) {
        if (items == null || items.length == 0) {
          this.selectedIndex = -1
        }
      },
      onRowClicked(item, index, event) {
        this.selectedIndex = index
      },
      deleteAllProducts(showMsg) {
        if (this.ticketItems.length > 0) {
          if(showMsg){
            this.$bvModal
              .msgBoxConfirm('Do you want to Park current Sale?', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'YES',
                cancelTitle: 'NO',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true,
                noCloseOnBackdrop: true,
                noCloseOnEsc:true
              })
              .then(value => {
                if (value == true) {
                  console.log(value)
                  this.parkSale()
                } else {
                  this.ticketItems = []
                }
              })
              .catch(err => {
                this.showErrorMsg({
                  message: err
                })
              })
          }
          else{
              this.ticketItems = [];
          }

        }
      },
      getProductsSelected() {
        if (this.ticketItems.length > 0) {
          const tempTicketItems = JSON.parse(JSON.stringify(this.ticketItems))
          return tempTicketItems
        } else {
          return null
        }
      },
      getLineItemsSize(){
        return this.ticketItems.length;
      },
      parkSale() {
        if (this.ticketItems.length > 0) {
          const tempTicketItems = JSON.parse(JSON.stringify(this.ticketItems))
          let now = Date.now()
          let newParkSale = {
            saleDateTime: now,
            saleData: tempTicketItems
          }

          this.parkItems.push(newParkSale)
          console.log(this.parkItems)
          this.ticketItems = []
          this.showSuccessMsg({
            message: 'Current Sale Parked successfully.'
          })
        } else {
          this.showErrorMsg({
            message: 'No sale found to park.'
          })
        }
      },
      retrieveParkedSale() {
        if (Object.keys(this.parkItems).length > 0) {
          this.$refs.modalParkedSalesTable.show()
        } else {
          this.showErrorMsg({
            message: 'No parked sale found.'
          })
        }
      },
      setBarcodeInputFocus() {
        if (this.$refs.barCodeInput != null) {
          this.$refs.barCodeInput.focus()
        }
      }
    },
    updated: function() {
      this.$nextTick(function() {
        this.$emit('updated')
      })
    }
  }

</script>
